exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-tabs.flex-column .nav-item.show .nav-link[data-v-6e74c9f6],.nav-tabs.flex-column .nav-link.active[data-v-6e74c9f6]{border-left:3px solid #17a2b8}.nav-item active[data-v-6e74c9f6]{background-color:#17a2b8}.list-group-item[data-v-6e74c9f6]{padding:2px 0}.profile-username[data-v-6e74c9f6]{font-size:20px;margin-top:5px}.nav-link[data-v-6e74c9f6]{font-weight:600}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6e74c9f6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/onlineadmission/documentVerification.vue
// module id = 303
// module chunks = 0